import type { Invoice } from "src/types";

/** Billed patient is a linked record under another account holder (not the insured person). */
export function invoiceBilledPatientIsLinked(invoice: Invoice): boolean {
    if (!invoice.patient || !invoice.recipient) return false;
    if (invoice.recipientIsPatient === true) return false;
    if (invoice.recipientIsPatient === false) return true;

    const billedName = `${invoice.patient.firstName ?? ""} ${invoice.patient.lastName ?? ""}`
        .trim()
        .toLowerCase();
    const accountName = `${invoice.recipient.firstName ?? ""} ${invoice.recipient.lastName ?? ""}`
        .trim()
        .toLowerCase();
    return billedName !== accountName;
}
